import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import LazyLoad from 'react-lazyload'

const SliderCTA = dynamic(() => import('../../shared/SliderCTA'))

export const DynamicSliderCTA = ({ sliderProps = {}, isBottom }) => {
  const commonProps = {
    title: 'Looking for a loan alternative?',
    subtitle: 'Get rid of your debt with Freedom Debt Relief',
    btnLabel: 'Get your FREE plan now',
    btnMobileLabel: 'Get your FREE plan now',
    phone: '800-910-0065',
    mobileSpecific: false,
    ...sliderProps,
  }

  return (
    <>
      {/* {flag === 'control' && ( */}
      <LazyLoad>
        <SliderCTA
          {...commonProps}
          title="Achieve financial control. How much debt do you have?"
          subtitle=""
        />
      </LazyLoad>
      {/* )} */}
      {/* {flag === 'slider-a' && (
        <LazyLoad>
          <SliderCTA_A
            title="End your debt. Get a free evaluation today"
            btnLabel="Get started"
            btnMobileLabel="Get started"
            list={[
              'One low monthly program deposit',
              'Settlement for less than owned',
              'Debt could be resolved in 24-48 months',
            ]}
            {...sliderProps}
          />
        </LazyLoad>
      )} */}
      {/* {flag === 'slider-b' && (
        <LazyLoad>
          <SliderCTA_B
            {...commonProps}
            title="Looking for a loan alternative?"
            subtitle="Get rid of your debt with Freedom Debt Relief"
          />
        </LazyLoad>
      )} */}
      {/* {flag === 'slider-c' && (
        <LazyLoad>
          <SliderCTA_C className={classNames(!isBottom && 'mt-12')} />
        </LazyLoad>
      )} */}
    </>
  )
}

DynamicSliderCTA.propTypes = {
  flag: PropTypes.string.isRequired,
  isBottom: PropTypes.bool,
}

export default DynamicSliderCTA
